module.exports = __webpack_public_path__ + "static/media/1.fc7c905d.png";